module.exports = "/build/web/svg/icon-spinner--white.e774b22a3861ffbd9ad1c51fd1b56827.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/icon-spinner--white.svg
// module id = 114
// module chunks = 11